import { get, patch, post, deleteRequest } from "./api";

export const fetchAccounts = () => {
  return get("/api/v2/accounts/");
};

export const fetchCustomerAccounts = (
  customer_id,
  params = {},
  dropdown_format = false
) => {
  return get(
    `/api/v2/customers/${customer_id}/accounts/`,
    params,
    dropdown_format
  );
};

export const updateAccount = (customer_id, template, data) => {
  return patch(getAccountUrl(customer_id, template, data), data);
};

export const createAccount = (customer_id, template, data) => {
  return post(getAccountUrl(customer_id, template, data), data);
};

export const deleteAccount = (customer_id, template, data) => {
  return deleteRequest(getAccountUrl(customer_id, template, data), data);
};

export const fetchAccountTypes = () => {
  return get("/api/v2/accounttypes/", {}, true);
};

export const fetchAccountSubTypes = () => {
  return get("/api/v2/accountsubtypes/", {}, false).then((data) =>
    data.map((o) => ({ value: o.id, label: o.name, type: o.type }))
  );
};

export const fetchAccountTaxTypes = (set) => {
  return get("/api/v2/accounttaxtypes/", {}, true);
};

const getAccountUrl = (customer_id, template, data) => {
  var url = "/api/v2/";

  if (!template) {
    url += `customers/${customer_id}/accounts/`;
  } else {
    url += "accounts/";
  }

  if (data.id) {
    url += `${data.id}/`;
  }

  return url;
};

export const updateAccountBalance = (
  customer_id,
  account_id,
  date,
  balance
) => {
  return post("/api/v2/update_account_balance/", {
    customer_id,
    account_id,
    date,
    balance,
  });
};

export const recalculateCustomerBalances = (
  customer_id,
  options = {}
) => {
  return post("/api/v2/update_account_balance/recalculate/", {
    customer_id,
    ...options,
  });
};
